import apiClient from './apiClient'
import { registerTenantScopedReset } from '../tenancy/tenantScopedState'

export const PENDING_BILLING_ORDER_KEY = 'reldo.pendingBillingOrderId'

export async function getBillingOffers(client = apiClient) {
	const response = await client.get('/api/billing/offers')
	return response.data
}

export async function createBillingOrder(offerId, client = apiClient) {
	const response = await client.post('/api/billing/orders', { offerId })
	return response.data
}

export async function getBillingOrder(orderId, client = apiClient) {
	const response = await client.get(`/api/billing/orders/${encodeURIComponent(orderId)}`)
	return response.data
}

export function savePendingOrder(orderId, storage = window.sessionStorage) {
	storage.setItem(PENDING_BILLING_ORDER_KEY, orderId)
}

export function readPendingOrder(storage = window.sessionStorage) {
	return storage.getItem(PENDING_BILLING_ORDER_KEY)
}

export function clearPendingOrder(storage = window.sessionStorage) {
	storage.removeItem(PENDING_BILLING_ORDER_KEY)
}

registerTenantScopedReset('billing-pending-order', () => {
	if (typeof window !== 'undefined') clearPendingOrder(window.sessionStorage)
})

export function shouldPollOrder(state) {
	return state === 'pending' || state === 'expired'
}

export function formatOfferMoney(amountMinor, currency) {
	return new Intl.NumberFormat('ru-RU', {
		style: 'currency',
		currency,
	}).format(amountMinor / 100)
}

export function redirectToPayment(paymentUrl, location = window.location) {
	const url = new URL(paymentUrl)
	if (url.protocol !== 'https:' || url.hostname !== 'auth.robokassa.ru') {
		throw new Error('Unexpected payment provider URL')
	}
	location.assign(url.toString())
}
